import React from 'react';
import { Col,  Row, Card } from 'react-bootstrap';

export let Announcement = <Row className="justify-content-center align-items-center my-3">
          <Col className="col-auto">
            <Card bg='secondary' text='white' border='warning' style={{ width: '50rem' }}>
              <Card.Body>
                <Card.Title>
                  PoeMap.Trade is not longer needed due to the most recent map changes in 3.28.<br/>
                  If for some reason it makes sense to bring it back in another form I will.<br/>
                  For now, so long and thanks for all the fish!
                </Card.Title>
              </Card.Body>
            </Card>
          </Col>
        </Row>


/* export let Announcement = null */
